import { Component, input } from '@angular/core';
import { TypographyComponent } from '@purolator/ui-kit-angular';
import { TranslatePipe } from '../../../../core/i18n';
import type { EstimateBreakdownView } from './delivery-service-matrix';
import { formatCurrencyAmount } from './delivery-service-matrix';
import { EstimatedCostsSkeleton } from './estimated-costs-skeleton/estimated-costs-skeleton';

/**
 * Estimated-costs breakdown for the selected service offering.
 * Sticky sidebar at ≥1440px; hidden below 1440px (including under 1200px).
 * Shows the design-pack skeleton while the shared delivery rate call is pending.
 */
@Component({
  selector: 'app-estimated-costs-panel',
  imports: [TypographyComponent, TranslatePipe, EstimatedCostsSkeleton],
  templateUrl: './estimated-costs-panel.html',
  styleUrl: './estimated-costs-panel.scss',
})
export class EstimatedCostsPanel {
  readonly breakdown = input.required<EstimateBreakdownView | null>();
  /** True while the delayed delivery/costs skeleton should paint. */
  readonly showSkeleton = input(false);
  /** True while the initial rate call is unresolved, including the pre-skeleton delay. */
  readonly pending = input(false);

  protected readonly formatCurrencyAmount = formatCurrencyAmount;

  /**
   * Resolves an i18n label for a surcharge/accessorial label code.
   * Complimentary RES uses "Signature Required – Included" (OM-786 AC5).
   */
  protected surchargeLabelKey(labelCode: string, displayMode?: 'amount' | 'included'): string {
    if (displayMode === 'included' && labelCode === 'RES') {
      return 'createShipment.serviceStep.deliveryService.breakdown.surcharges.RESIncluded';
    }
    return `createShipment.serviceStep.deliveryService.breakdown.surcharges.${labelCode}`;
  }

  /**
   * Formats the backend coupon rate for the localized Pay only line.
   */
  protected discountParams(rate: number): Record<string, string> {
    return { rate: String(rate) };
  }
}
